module.exports = __webpack_public_path__ + "img/person1.3647ba84.svg";